import React from "react";
// import Header from "./components/Header/header";
// import Header from './newComponents/Navbar'
// import Footer from './components/Footer/footer'
// import Namiation from './components/FramerAnimation/FramerAnimation'
import Hero from './components/Hero/Hero'
// import Testing from './components/TestingAnimation/Testing'
// import Swiper from './components/Swiper/Swiper';
import Grid from './components/grid/grid'
import Retail from './components/Entreprise/RetailMore'
import Animation from './components/Animation/Animation';
import Intro from './newComponents/Introduction/Intro';
import Systems from './newComponents/Systems/Systems';
import Clients from './newComponents/Clients/Clients';
import Counter from './newComponents/Counter/Counter';
import Technology from './components/Technology/Technology';
import Scrollstack from './components/Scrollstack/Scrollstack'; 
import Platform from './components/Platform/Platform'; 
import Telecom from './components/Telecom/Telecom'; 

import Solution from "./components/Solution/Solution";

const Home = () => {
  return (
    <div>
      <Hero />
      <Animation />
      {/* <Namiation /> */}
      {/* <Intro /> */}
      {/* <Systems /> */}
      {/* <Testing/> */}
      <Technology/>
      <Counter/>
      <Scrollstack/>
      <Solution/>
      {/* <Grid/> */}
      <Platform/>
      <Telecom/>
      <Clients />
      {/* <Entreprise /> */}
      <Retail/>
    </div>
  );
};

export default Home;
